var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComingsoon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: "100%",
    width: "100%",
    viewBox: "0 0 816 372",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: "100%",
    width: "100%"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M-101.437,3.5C-101.437,3.5,-101.437,2.18,-101.437,2.18C-101.437,-17.019,-90.517,-26.739,-76.598,-26.739C-61.959,-26.739,-51.639,-17.379,-51.639,1.939C-51.639,1.939,-51.639,3.02,-51.639,3.02C-51.639,22.339,-62.558,32.179,-76.598,32.179C-91.237,32.179,-101.437,22.819,-101.437,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M-54.519,3.26C-54.519,3.26,-54.519,1.7,-54.519,1.7C-54.519,-16.659,-63.759,-24.219,-76.598,-24.219C-89.317,-24.219,-98.557,-15.219,-98.557,2.06C-98.557,2.06,-98.557,3.74,-98.557,3.74C-98.557,21.499,-89.437,29.659,-76.598,29.659C-63.759,29.659,-54.519,20.9,-54.519,3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M-40.958,-25.898C-40.958,-25.898,-38.079,-25.898,-38.079,-25.898C-38.079,-25.898,-38.079,-20.259,-38.079,-20.259C-38.079,-20.259,-37.838,-20.259,-37.838,-20.259C-30.758,-24.579,-23.92,-26.739,-17.56,-26.739C-10.84,-26.739,-6.159,-24.459,-3.76,-19.899C-3.76,-19.899,-3.52,-19.899,-3.52,-19.899C4.64,-25.058,11.599,-26.739,17.839,-26.739C27.198,-26.739,33.558,-22.539,33.558,-11.739C33.558,-11.739,33.558,31.339,33.558,31.339C33.558,31.339,30.678,31.339,30.678,31.339C30.678,31.339,30.678,-11.26,30.678,-11.26C30.678,-20.739,25.519,-24.099,16.999,-24.099C11.239,-24.099,4.64,-22.299,-3.04,-17.619C-2.56,-15.939,-2.2,-14.139,-2.2,-11.739C-2.2,-11.739,-2.2,31.339,-2.2,31.339C-2.2,31.339,-5.32,31.339,-5.32,31.339C-5.32,31.339,-5.32,-11.26,-5.32,-11.26C-5.32,-20.739,-9.76,-24.099,-18.16,-24.099C-24.639,-24.099,-30.999,-22.059,-37.958,-17.499C-37.958,-17.499,-37.958,31.339,-37.958,31.339C-37.958,31.339,-40.958,31.339,-40.958,31.339C-40.958,31.339,-40.958,-25.898,-40.958,-25.898Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M47.12,-43.658C47.12,-43.658,50.24,-43.658,50.24,-43.658C50.24,-43.658,50.24,-39.219,50.24,-39.219C50.24,-39.219,47.12,-39.219,47.12,-39.219C47.12,-39.219,47.12,-43.658,47.12,-43.658Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M47.24,-26.019C47.24,-26.019,50.24,-26.019,50.24,-26.019C50.24,-26.019,50.24,31.099,50.24,31.099C50.24,31.099,47.24,31.099,47.24,31.099C47.24,31.099,47.24,-26.019,47.24,-26.019Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M63.919,-25.898C63.919,-25.898,66.799,-25.898,66.799,-25.898C66.799,-25.898,66.799,-20.259,66.799,-20.259C66.799,-20.259,67.04,-20.259,67.04,-20.259C74.119,-24.579,82.159,-26.739,89.358,-26.739C99.917,-26.739,105.917,-22.539,105.917,-11.739C105.917,-11.739,105.917,31.339,105.917,31.339C105.917,31.339,102.917,31.339,102.917,31.339C102.917,31.339,102.917,-11.26,102.917,-11.26C102.917,-20.739,98.358,-24.099,88.279,-24.099C81.319,-24.099,73.878,-21.939,66.919,-17.499C66.919,-17.499,66.919,31.339,66.919,31.339C66.919,31.339,63.919,31.339,63.919,31.339C63.919,31.339,63.919,-25.898,63.919,-25.898Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M113.838,34.698C113.838,27.138,119.358,25.219,125.958,22.699C125.958,22.699,125.958,22.459,125.958,22.459C122.839,21.859,119.838,19.099,119.838,14.899C119.838,11.42,122.238,8.9,125.358,6.02C120.798,3.26,118.158,-1.78,118.158,-8.019C118.158,-8.019,118.158,-8.979,118.158,-8.979C118.158,-19.899,126.678,-26.499,138.437,-26.499C140.958,-26.499,143.237,-26.258,145.397,-25.779C145.397,-25.779,163.997,-25.779,163.997,-25.779C163.997,-25.779,163.997,-23.259,163.997,-23.259C163.997,-23.259,150.437,-23.259,150.437,-23.259C155.357,-20.619,158.237,-15.82,158.237,-9.22C158.237,-9.22,158.237,-8.019,158.237,-8.019C158.237,3.38,149.838,9.5,138.318,9.5C134.118,9.5,130.398,8.9,127.158,7.22C124.879,9.26,122.838,10.94,122.838,14.18C122.838,18.02,125.478,20.539,130.038,20.539C130.038,20.539,147.197,20.539,147.197,20.539C157.037,20.539,164.356,21.379,164.356,32.059C164.356,41.538,156.917,49.698,137.958,49.698C120.318,49.698,113.838,42.978,113.838,34.698Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M161.357,32.419C161.357,23.419,155.477,23.419,146.837,23.419C146.837,23.419,129.438,23.419,129.438,23.419C122.358,25.699,116.959,27.259,116.959,34.459C116.959,41.538,122.117,47.059,137.837,47.059C154.996,47.059,161.357,40.458,161.357,32.419Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M155.237,-7.899C155.237,-7.899,155.237,-9.22,155.237,-9.22C155.237,-19.299,148.397,-24.099,138.318,-24.099C128.118,-24.099,121.158,-18.699,121.158,-9.22C121.158,-9.22,121.158,-7.899,121.158,-7.899C121.158,1.821,128.238,7.1,138.318,7.1C148.517,7.1,155.237,1.821,155.237,-7.899Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,393.5,187)",
    visibility: "hidden",
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369,156C369,162.628,203.569,169,-0.5,169C-204.569,169,-370,162.628,-370,156C-370,155.703,-369.654,155.408,-369,155.116C-369,155.116,-369,137.068,-369,137.068C-369,137.068,-369,108.67,-369,108.67C-369,108.67,-358.869,108.67,-358.869,108.67C-358.869,108.67,-358.869,103.937,-358.869,103.937C-358.869,103.937,-344.473,103.937,-344.473,103.937C-344.473,103.937,-344.473,108.67,-344.473,108.67C-344.473,108.67,-341.274,108.67,-341.274,108.67C-341.274,108.67,-341.274,110.248,-341.274,110.248C-341.274,110.248,-336.475,110.248,-336.475,110.248C-336.475,110.248,-336.475,100.781,-336.475,100.781C-336.475,100.781,-333.276,100.781,-333.276,100.781C-333.276,100.781,-333.276,97.626,-333.276,97.626C-333.276,97.626,-318.88,97.626,-318.88,97.626C-318.88,97.626,-318.88,100.781,-318.88,100.781C-318.88,100.781,-317.281,100.781,-317.281,100.781C-317.281,100.781,-317.281,50.296,-317.281,50.296C-317.281,50.296,-315.681,50.296,-315.681,50.296C-315.681,50.296,-315.681,45.563,-315.681,45.563C-315.681,45.563,-301.285,45.563,-301.285,45.563C-301.285,45.563,-301.285,50.296,-301.285,50.296C-301.285,50.296,-293.287,50.296,-293.287,50.296C-293.287,50.296,-293.287,78.694,-293.287,78.694C-293.287,78.694,-283.69,78.694,-283.69,78.694C-283.69,78.694,-283.69,28.209,-283.69,28.209C-283.69,28.209,-278.891,28.209,-278.891,28.209C-278.891,28.209,-278.891,20.32,-278.891,20.32C-278.891,20.32,-269.294,20.32,-269.294,20.32C-269.294,20.32,-269.294,10.854,-269.294,10.854C-269.294,10.854,-254.897,10.854,-254.897,10.854C-254.897,10.854,-254.897,28.209,-254.897,28.209C-254.897,28.209,-245.3,28.209,-245.3,28.209C-245.3,28.209,-245.3,92.893,-245.3,92.893C-245.3,92.893,-234.103,92.893,-234.103,92.893C-234.103,92.893,-234.103,39.252,-234.103,39.252C-234.103,39.252,-226.105,39.252,-226.105,39.252C-226.105,39.252,-226.105,18.743,-226.105,18.743C-226.105,18.743,-205.311,18.743,-205.311,18.743C-205.311,18.743,-205.311,39.252,-205.311,39.252C-205.311,39.252,-200.512,39.252,-200.512,39.252C-200.512,39.252,-200.512,-39.631,-200.512,-39.631C-200.512,-39.631,-194.114,-39.631,-194.114,-39.631C-194.114,-39.631,-194.114,-49.097,-194.114,-49.097C-194.114,-49.097,-192.514,-49.097,-192.514,-49.097C-192.514,-49.097,-192.514,-69.607,-192.514,-69.607C-192.514,-69.607,-189.315,-69.607,-189.315,-69.607C-189.315,-69.607,-189.315,-74.34,-189.315,-74.34C-189.315,-74.34,-187.716,-74.34,-187.716,-74.34C-187.716,-74.34,-187.716,-110.626,-187.716,-110.626C-187.716,-110.626,-182.917,-110.626,-182.917,-110.626C-182.917,-110.626,-182.917,-74.34,-182.917,-74.34C-182.917,-74.34,-181.317,-74.34,-181.317,-74.34C-181.317,-74.34,-181.317,-69.607,-181.317,-69.607C-181.317,-69.607,-178.118,-69.607,-178.118,-69.607C-178.118,-69.607,-178.118,-49.097,-178.118,-49.097C-178.118,-49.097,-176.519,-49.097,-176.519,-49.097C-176.519,-49.097,-176.519,-39.631,-176.519,-39.631C-176.519,-39.631,-170.121,-39.631,-170.121,-39.631C-170.121,-39.631,-170.121,50.296,-170.121,50.296C-170.121,50.296,-165.322,50.296,-165.322,50.296C-165.322,50.296,-165.322,-115.359,-165.322,-115.359C-165.322,-115.359,-146.127,-115.359,-146.127,-115.359C-146.127,-115.359,-146.127,-126.403,-146.127,-126.403C-146.127,-126.403,-130.131,-131.136,-130.131,-131.136C-130.131,-131.136,-130.131,-137.447,-130.131,-137.447C-130.131,-137.447,-115.735,-142.18,-115.735,-142.18C-115.735,-142.18,-112.536,-142.18,-112.536,-142.18C-112.536,-142.18,-112.536,-115.359,-112.536,-115.359C-112.536,-115.359,-109.337,-115.359,-109.337,-115.359C-109.337,-115.359,-109.337,20.32,-109.337,20.32C-109.337,20.32,-102.939,20.32,-102.939,20.32C-102.939,20.32,-102.939,-61.718,-102.939,-61.718C-102.939,-61.718,-86.943,-61.718,-86.943,-61.718C-86.943,-61.718,-86.943,-72.762,-86.943,-72.762C-86.943,-72.762,-80.545,-72.762,-80.545,-72.762C-80.545,-72.762,-80.545,-71.184,-80.545,-71.184C-80.545,-71.184,-74.147,-71.184,-74.147,-71.184C-74.147,-71.184,-74.147,-69.607,-74.147,-69.607C-74.147,-69.607,-66.149,-69.607,-66.149,-69.607C-66.149,-69.607,-66.149,48.719,-66.149,48.719C-66.149,48.719,-53.352,48.719,-53.352,48.719C-53.352,48.719,-53.352,-39.631,-53.352,-39.631C-53.352,-39.631,-43.755,-39.631,-43.755,-39.631C-43.755,-39.631,-43.755,-69.607,-43.755,-69.607C-43.755,-69.607,-38.956,-69.607,-38.956,-69.607C-38.956,-69.607,-38.956,-105.893,-38.956,-105.893C-38.956,-105.893,-32.558,-105.893,-32.558,-105.893C-32.558,-105.893,-32.558,-116.937,-32.558,-116.937C-32.558,-116.937,-22.96,-116.937,-22.96,-116.937C-22.96,-116.937,-22.96,-169,-22.96,-169C-22.96,-169,-18.162,-169,-18.162,-169C-18.162,-169,-18.162,-116.937,-18.162,-116.937C-18.162,-116.937,-8.564,-116.937,-8.564,-116.937C-8.564,-116.937,-8.564,-105.893,-8.564,-105.893C-8.564,-105.893,-2.166,-105.893,-2.166,-105.893C-2.166,-105.893,-2.166,-69.607,-2.166,-69.607C-2.166,-69.607,2.633,-69.607,2.633,-69.607C2.633,-69.607,2.633,-39.631,2.633,-39.631C2.633,-39.631,10.631,-39.631,10.631,-39.631C10.631,-39.631,10.631,64.495,10.631,64.495C10.631,64.495,18.628,64.495,18.628,64.495C18.628,64.495,18.628,7.699,18.628,7.699C18.628,7.699,26.626,7.699,26.626,7.699C26.626,7.699,26.626,-15.966,26.626,-15.966C26.626,-15.966,42.622,-15.966,42.622,-15.966C42.622,-15.966,42.622,-42.786,42.622,-42.786C42.622,-42.786,58.618,-42.786,58.618,-42.786C58.618,-42.786,58.618,7.699,58.618,7.699C58.618,7.699,79.412,7.699,79.412,7.699C79.412,7.699,79.412,66.073,79.412,66.073C79.412,66.073,85.81,66.073,85.81,66.073C85.81,66.073,85.81,-56.985,85.81,-56.985C85.81,-56.985,114.602,-64.874,114.602,-64.874C114.602,-64.874,114.602,-79.073,114.602,-79.073C114.602,-79.073,138.596,-72.762,138.596,-72.762C138.596,-72.762,138.596,34.519,138.596,34.519C138.596,34.519,146.594,34.519,146.594,34.519C146.594,34.519,146.594,-58.563,146.594,-58.563C146.594,-58.563,170.587,-79.073,170.587,-79.073C170.587,-79.073,194.581,-58.563,194.581,-58.563C194.581,-58.563,194.581,72.383,194.581,72.383C194.581,72.383,204.178,72.383,204.178,72.383C204.178,72.383,204.178,34.519,204.178,34.519C204.178,34.519,216.975,-55.408,216.975,-55.408C216.975,-55.408,228.172,34.519,228.172,34.519C228.172,34.519,228.172,50.296,228.172,50.296C228.172,50.296,231.371,50.296,231.371,50.296C231.371,50.296,231.371,20.32,231.371,20.32C231.371,20.32,239.369,20.32,239.369,20.32C239.369,20.32,239.369,-0.189,239.369,-0.189C239.369,-0.189,252.165,-0.189,252.165,-0.189C252.165,-0.189,252.165,12.432,252.165,12.432C252.165,12.432,261.763,12.432,261.763,12.432C261.763,12.432,261.763,50.296,261.763,50.296C261.763,50.296,264.962,50.296,264.962,50.296C264.962,50.296,264.962,92.893,264.962,92.893C264.962,92.893,274.559,92.893,274.559,92.893C274.559,92.893,274.559,64.495,274.559,64.495C274.559,64.495,279.358,64.495,279.358,64.495C279.358,64.495,279.358,55.029,279.358,55.029C279.358,55.029,296.953,55.029,296.953,55.029C296.953,55.029,296.953,64.495,296.953,64.495C296.953,64.495,301.752,64.495,301.752,64.495C301.752,64.495,301.752,97.626,301.752,97.626C301.752,97.626,304.951,97.626,304.951,97.626C304.951,97.626,304.951,89.738,304.951,89.738C304.951,89.738,306.55,89.738,306.55,89.738C306.55,89.738,306.55,85.005,306.55,85.005C306.55,85.005,312.949,85.005,312.949,85.005C312.949,85.005,312.949,81.85,312.949,81.85C312.949,81.85,324.146,81.85,324.146,81.85C324.146,81.85,324.146,89.738,324.146,89.738C324.146,89.738,328.945,89.738,328.945,89.738C328.945,89.738,328.945,94.471,328.945,94.471C328.945,94.471,341.741,94.471,341.741,94.471C341.741,94.471,341.741,100.781,341.741,100.781C341.741,100.781,348.139,100.781,348.139,100.781C348.139,100.781,348.139,85.005,348.139,85.005C348.139,85.005,370,85.005,370,85.005C370,85.005,370,156,370,156C370,156,369,156,369,156Z",
    fillRule: "evenodd",
    fill: "#f0f0f0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53,
    id: "i2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(190,160)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "190 160; 220 160",
    keyTimes: "0; 1",
    keySplines: "0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-235.5,-256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,236,254.5)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 2,
    stroke: "#5e5e5e",
    fill: "#ffffff",
    d: "M7,-6.5C5.345,-9.292,4,-12.5,-1.5,-12.5C-5.358,-12.5,-8.512,-8.803,-10,-5.5C-16,-5.5,-21,-2.5,-20,3C-18.864,9.249,-11.046,12.5,0,12.5C11.046,12.5,19.034,9.277,20,3C21,-3.5,16,-7.5,7,-6.5Z"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    id: "i4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(641,59)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "641 59; 661 59",
    keyTimes: "0; 1",
    keySplines: "0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-685.5,-156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,687.169,154.5)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 2,
    stroke: "#5e5e5e",
    fill: "#ffffff",
    d: "M5.32,-4.94C4.062,-7.062,3.04,-9.5,-1.14,-9.5C-4.072,-9.5,-6.469,-6.69,-7.6,-4.18C-12.16,-4.18,-15.96,-1.9,-15.2,2.28C-14.336,7.029,-8.395,9.5,0,9.5C8.395,9.5,14.466,7.051,15.2,2.28C15.96,-2.66,12.16,-5.7,5.32,-4.94Z"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-46,-93)",
    id: "i5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i6",
    transform: "matrix(1,0,0,1,585,244)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M-6.5,-8.5C-6.5,-8.5,6.5,-8.5,6.5,-8.5C6.5,-8.5,6.5,8.5,6.5,8.5C6.5,8.5,-6.5,8.5,-6.5,8.5C-6.5,8.5,-6.5,-8.5,-6.5,-8.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,585,244)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6b6b6b",
    fillRule: "evenodd",
    d: "M5,7C5,7,-5,7,-5,7C-5,7,-5,-7,-5,-7C-5,-7,5,-7,5,-7C5,-7,5,7,5,7ZM8,-10C8,-10,-8,-10,-8,-10C-8,-10,-8,10,-8,10C-8,10,8,10,8,10C8,10,8,-10,8,-10Z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-46,-93)",
    id: "i7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i6",
    transform: "matrix(1,0,0,1,585,236.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M-23.5,-11C-23.5,-11,23.5,-11,23.5,-11C23.5,-11,23.5,11,23.5,11C23.5,11,-23.5,11,-23.5,11C-23.5,11,-23.5,-11,-23.5,-11Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,585,236.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6b6b6b",
    fillRule: "evenodd",
    d: "M22,9.5C22,9.5,-22,9.5,-22,9.5C-22,9.5,-22,-9.5,-22,-9.5C-22,-9.5,22,-9.5,22,-9.5C22,-9.5,22,9.5,22,9.5ZM25,-12.5C25,-12.5,-25,-12.5,-25,-12.5C-25,-12.5,-25,12.5,-25,12.5C-25,12.5,25,12.5,25,12.5C25,12.5,25,-12.5,25,-12.5Z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-46,-93)",
    id: "i8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,722.875,236.375)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 2,
    stroke: "#999999",
    d: "M-112.625,-6.125C-112.625,-6.125,-93.375,6.125,-93.375,6.125C-93.375,6.125,-68.375,-5.875,-68.375,-5.875C-68.375,-5.875,-48.375,6.125,-48.375,6.125C-48.375,6.125,-22.375,-5.875,-22.375,-5.875C-22.375,-5.875,0.625,6.125,0.625,6.125C0.625,6.125,23.625,-5.875,23.625,-5.875C23.625,-5.875,46.625,6.125,46.625,6.125C46.625,6.125,67.625,-5.875,67.625,-5.875C67.625,-5.875,90.625,6.125,90.625,6.125C90.625,6.125,112.625,-5.875,112.625,-5.875"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "i9"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(539.125,161.063)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; -3; 2; -1; 1; 0; 0",
    keyTimes: "0; 0.24; 0.333333; 0.4; 0.466667; 0.52; 0.56; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,0.24)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "1 0.24; 1 0.96; 1 0.96",
    keyTimes: "0; 0.266667; 1",
    keySplines: "1 0.011 0.833 0.833; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-585.125,-253.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i6",
    transform: "matrix(1,0,0,1,585,300.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M1,46.5C1,46.5,-1,46.5,-1,46.5C-1,46.5,-1,-46.5,-1,-46.5C-1,-46.5,1,-46.5,1,-46.5C1,-46.5,1,46.5,1,46.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,585,300.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6b6b6b",
    d: "M1,-46.5C1,-46.5,-1,-46.5,-1,-46.5C-1,-46.5,-1,46.5,-1,46.5C-1,46.5,1,46.5,1,46.5C1,46.5,1,-46.5,1,-46.5Z"
  })))))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "i10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(537.938,182.156)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "537.938 182.156; 539.219 249.156; 542.875 249.156; 535.188 249.656; 539.812 249.281; 536.812 249.281; 538.062 249.531; 538.125 250.875; 538.125 250.875",
    keyTimes: "0; 0.266666; 0.333333; 0.4; 0.466667; 0.52; 0.56; 0.586667; 1",
    keySplines: "1 0.012 0.833 0.833; 0.167 0 1 1; 0.167 0 1 1; 0.167 0 1 1; 0.167 0 1 1; 0.167 0 1 1; 0.167 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; -14; 9; -14; 4; 0; -99; -99",
    keyTimes: "0; 0.24; 0.333333; 0.4; 0.466667; 0.52; 0.56; 0.586667; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-0.031,10.938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.025,11C-5.762,11,-10.469,6.606,-10.975,1C-10.975,1,-8.967,1,-8.967,1C-8.469,5.499,-4.657,9,-0.025,9C4.946,9,8.975,4.971,8.975,0C8.975,-4.971,4.946,-9,-0.025,-9C-0.025,-9,-0.025,-11,-0.025,-11C6.05,-11,10.975,-6.075,10.975,0C10.975,6.075,6.05,11,-0.025,11Z",
    fillRule: "evenodd",
    fill: "#6b6b6b"
  })))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-46,-93)",
    id: "i11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,722.875,236.375)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 2,
    stroke: "#999999",
    d: "M-112.625,6.125C-112.625,6.125,-93.375,-6.125,-93.375,-6.125C-93.375,-6.125,-68.375,5.875,-68.375,5.875C-68.375,5.875,-48.375,-6.125,-48.375,-6.125C-48.375,-6.125,-22.375,5.875,-22.375,5.875C-22.375,5.875,0.625,-6.125,0.625,-6.125C0.625,-6.125,23.625,5.875,23.625,5.875C23.625,5.875,46.625,-6.125,46.625,-6.125C46.625,-6.125,67.625,5.875,67.625,5.875C67.625,5.875,90.625,-6.125,90.625,-6.125C90.625,-6.125,112.625,5.875,112.625,5.875"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-46,-93)",
    id: "i12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i6",
    transform: "matrix(1,0,0,1,760,406.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M-24.5,-11C-24.5,-11,24.5,-11,24.5,-11C24.5,-11,24.5,11,24.5,11C24.5,11,-24.5,11,-24.5,11C-24.5,11,-24.5,-11,-24.5,-11Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,760,406.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6b6b6b",
    fillRule: "evenodd",
    d: "M23,9.5C23,9.5,-23,9.5,-23,9.5C-23,9.5,-23,-9.5,-23,-9.5C-23,-9.5,23,-9.5,23,-9.5C23,-9.5,23,9.5,23,9.5ZM26,-12.5C26,-12.5,-26,-12.5,-26,-12.5C-26,-12.5,-26,12.5,-26,12.5C-26,12.5,26,12.5,26,12.5C26,12.5,26,-12.5,26,-12.5Z"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-46,-93)",
    id: "i13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i6",
    transform: "matrix(1,0,0,1,760,423)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M-37.5,-5.5C-37.5,-5.5,37.5,-5.5,37.5,-5.5C37.5,-5.5,37.5,5.5,37.5,5.5C37.5,5.5,-37.5,5.5,-37.5,5.5C-37.5,5.5,-37.5,-5.5,-37.5,-5.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,760,423)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6b6b6b",
    fillRule: "evenodd",
    d: "M36,4C36,4,-36,4,-36,4C-36,4,-36,-4,-36,-4C-36,-4,36,-4,36,-4C36,-4,36,4,36,4ZM39,-7C39,-7,-39,-7,-39,-7C-39,-7,-39,7,-39,7C-39,7,39,7,39,7C39,7,39,-7,39,-7Z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-46,-93)",
    id: "i14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i6",
    transform: "matrix(1,0,0,1,759,437)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M-53.5,-9.5C-53.5,-9.5,53.5,-9.5,53.5,-9.5C53.5,-9.5,53.5,9.5,53.5,9.5C53.5,9.5,-53.5,9.5,-53.5,9.5C-53.5,9.5,-53.5,-9.5,-53.5,-9.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,759,437)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6b6b6b",
    fillRule: "evenodd",
    d: "M52,8C52,8,-52,8,-52,8C-52,8,-52,-8,-52,-8C-52,-8,52,-8,52,-8C52,-8,52,8,52,8ZM55,-11C55,-11,-55,-11,-55,-11C-55,-11,-55,11,-55,11C-55,11,55,11,55,11C55,11,55,-11,55,-11Z"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-46,-93)",
    id: "i15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "matrix(1,0,0,1,631,235.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M-1,5.5C-1,5.5,1,5.5,1,5.5C1,5.5,1,-5.5,1,-5.5C1,-5.5,-1,-5.5,-1,-5.5C-1,-5.5,-1,5.5,-1,5.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i17",
    transform: "matrix(1,0,0,1,654,235.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M-1,5.5C-1,5.5,1,5.5,1,5.5C1,5.5,1,-5.5,1,-5.5C1,-5.5,-1,-5.5,-1,-5.5C-1,-5.5,-1,5.5,-1,5.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i18",
    transform: "matrix(1,0,0,1,675,235.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M-1,5.5C-1,5.5,1,5.5,1,5.5C1,5.5,1,-5.5,1,-5.5C1,-5.5,-1,-5.5,-1,-5.5C-1,-5.5,-1,5.5,-1,5.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i19",
    transform: "matrix(1,0,0,1,700,235.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M-1,5.5C-1,5.5,1,5.5,1,5.5C1,5.5,1,-5.5,1,-5.5C1,-5.5,-1,-5.5,-1,-5.5C-1,-5.5,-1,5.5,-1,5.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i20",
    transform: "matrix(1,0,0,1,724,235.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M-1,5.5C-1,5.5,1,5.5,1,5.5C1,5.5,1,-5.5,1,-5.5C1,-5.5,-1,-5.5,-1,-5.5C-1,-5.5,-1,5.5,-1,5.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i21",
    transform: "matrix(1,0,0,1,747,235.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M-1,5.5C-1,5.5,1,5.5,1,5.5C1,5.5,1,-5.5,1,-5.5C1,-5.5,-1,-5.5,-1,-5.5C-1,-5.5,-1,5.5,-1,5.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i22",
    transform: "matrix(1,0,0,1,770,235.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M-1,5.5C-1,5.5,1,5.5,1,5.5C1,5.5,1,-5.5,1,-5.5C1,-5.5,-1,-5.5,-1,-5.5C-1,-5.5,-1,5.5,-1,5.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i6",
    transform: "matrix(1,0,0,1,791,235.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M-1,5.5C-1,5.5,1,5.5,1,5.5C1,5.5,1,-5.5,1,-5.5C1,-5.5,-1,-5.5,-1,-5.5C-1,-5.5,-1,5.5,-1,5.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,813,235.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M-1,5.5C-1,5.5,1,5.5,1,5.5C1,5.5,1,-5.5,1,-5.5C1,-5.5,-1,-5.5,-1,-5.5C-1,-5.5,-1,5.5,-1,5.5Z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-46,-93)",
    id: "i23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,721,236)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6b6b6b",
    d: "M-114,-8C-114,-8,-114,8,-114,8C-114,8,114,8,114,8C114,8,114,5,114,5C114,5,-111,5,-111,5C-111,5,-111,-5,-111,-5C-111,-5,114,-5,114,-5C114,-5,114,-8,114,-8C114,-8,-114,-8,-114,-8Z"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-46,-93)",
    id: "i24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,759.25,319)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 2,
    stroke: "#6b6b6b",
    d: "M-13.75,-76.5C-13.75,-76.5,13.75,-55.5,13.75,-55.5C13.75,-55.5,-13.75,-32.5,-13.75,-32.5C-13.75,-32.5,13.75,-10.5,13.75,-10.5C13.75,-10.5,-13.75,10.5,-13.75,10.5C-13.75,10.5,13.75,32.5,13.75,32.5C13.75,32.5,-13.75,54.5,-13.75,54.5C-13.75,54.5,13.75,76.5,13.75,76.5"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-46,-93)",
    id: "i25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,760.25,320)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 2,
    stroke: "#6b6b6b",
    d: "M13.75,-76.5C13.75,-76.5,-13.75,-55.5,-13.75,-55.5C-13.75,-55.5,13.75,-32.5,13.75,-32.5C13.75,-32.5,-13.75,-10.5,-13.75,-10.5C-13.75,-10.5,13.75,10.5,13.75,10.5C13.75,10.5,-13.75,32.5,-13.75,32.5C-13.75,32.5,13.75,54.5,13.75,54.5C13.75,54.5,-13.75,76.5,-13.75,76.5"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-46,-93)",
    id: "i26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,760,319)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6b6b6b",
    fillRule: "evenodd",
    d: "M13,75C13,75,-13,75,-13,75C-13,75,-13,-75,-13,-75C-13,-75,13,-75,13,-75C13,-75,13,75,13,75ZM16,-78C16,-78,-16,-78,-16,-78C-16,-78,-16,78,-16,78C-16,78,16,78,16,78C16,78,16,-78,16,-78Z"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-46,-93)",
    id: "i27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i19",
    transform: "matrix(1,0,0,1,760,265)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6b6b6b",
    d: "M13,-1C13,-1,-13,-1,-13,-1C-13,-1,-13,1,-13,1C-13,1,13,1,13,1C13,1,13,-1,13,-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i20",
    transform: "matrix(1,0,0,1,760,286)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6b6b6b",
    d: "M13,-1C13,-1,-13,-1,-13,-1C-13,-1,-13,1,-13,1C-13,1,13,1,13,1C13,1,13,-1,13,-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i21",
    transform: "matrix(1,0,0,1,760,309)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6b6b6b",
    d: "M13,-1C13,-1,-13,-1,-13,-1C-13,-1,-13,1,-13,1C-13,1,13,1,13,1C13,1,13,-1,13,-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i22",
    transform: "matrix(1,0,0,1,760,330)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6b6b6b",
    d: "M13,-1C13,-1,-13,-1,-13,-1C-13,-1,-13,1,-13,1C-13,1,13,1,13,1C13,1,13,-1,13,-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i6",
    transform: "matrix(1,0,0,1,760,351)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6b6b6b",
    d: "M13,-1C13,-1,-13,-1,-13,-1C-13,-1,-13,1,-13,1C-13,1,13,1,13,1C13,1,13,-1,13,-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,760,374)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6b6b6b",
    d: "M13,-1C13,-1,-13,-1,-13,-1C-13,-1,-13,1,-13,1C-13,1,13,1,13,1C13,1,13,-1,13,-1Z"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-46,-93)",
    id: "i28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,734.5,262.5)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 3,
    stroke: "#6b6b6b",
    d: "M11,20C11,20,-11,0,-11,0C-11,0,-11,-20,-11,-20C-11,-20,11,-20,11,-20C11,-20,11,20,11,20Z"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,187.5,351.5)",
    id: "i29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8,-1.5C-8,-1.5,8,-1.5,8,-1.5C8,-1.5,8,1.5,8,1.5C8,1.5,-8,1.5,-8,1.5C-8,1.5,-8,-1.5,-8,-1.5Z",
    fillRule: "evenodd",
    fill: "#000000"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,222.5,351.5)",
    id: "i30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8,-1.5C-8,-1.5,8,-1.5,8,-1.5C8,-1.5,8,1.5,8,1.5C8,1.5,-8,1.5,-8,1.5C-8,1.5,-8,-1.5,-8,-1.5Z",
    fillRule: "evenodd",
    fill: "#000000"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.89,0,0,1,257.5,351.5)",
    id: "i31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8,-1.5C-8,-1.5,8,-1.5,8,-1.5C8,-1.5,8,1.5,8,1.5C8,1.5,-8,1.5,-8,1.5C-8,1.5,-8,-1.5,-8,-1.5Z",
    fillRule: "evenodd",
    fill: "#000000"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.92,0,0,1,274,351.5)",
    id: "i32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8,-1.5C-8,-1.5,8,-1.5,8,-1.5C8,-1.5,8,1.5,8,1.5C8,1.5,-8,1.5,-8,1.5C-8,1.5,-8,-1.5,-8,-1.5Z",
    fillRule: "evenodd",
    fill: "#000000"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,290,351.5)",
    id: "i33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8,-1.5C-8,-1.5,8,-1.5,8,-1.5C8,-1.5,8,1.5,8,1.5C8,1.5,-8,1.5,-8,1.5C-8,1.5,-8,-1.5,-8,-1.5Z",
    fillRule: "evenodd",
    fill: "#000000"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,329.5,351.5)",
    id: "i34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8,-1.5C-8,-1.5,8,-1.5,8,-1.5C8,-1.5,8,1.5,8,1.5C8,1.5,-8,1.5,-8,1.5C-8,1.5,-8,-1.5,-8,-1.5Z",
    fillRule: "evenodd",
    fill: "#000000"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "i35"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(620,351.375)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "620 351.375; 620 351.375; 638 351.375; 638 351.375",
    keyTimes: "0; 0.613333; 0.653333; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; 15; 0; 0",
    keyTimes: "0; 0.613333; 0.653333; 0.693333; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1 0.85; 1 1; 1 1",
    keyTimes: "0; 0.613333; 0.653333; 0.693333; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-27.25,-29.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,30.392C27,30.392,12,30.392,12,30.392C12,30.392,12,27.392,12,27.392C12,27.392,16.339,27.392,16.339,27.392C16.339,27.392,16.37,0.375,16.37,0.375C16.37,0.375,16.028,-19.396,15.402,-21.076C13.19,-24.42,9.039,-25.752,2.7,-25.752C-3.598,-25.752,-10.286,-23.964,-16.659,-20.337C-16.659,-20.337,-16.628,0.375,-16.628,0.375C-16.628,0.375,-16.659,27.392,-16.659,27.392C-16.659,27.392,-12,27.392,-12,27.392C-12,27.392,-12,30.392,-12,30.392C-12,30.392,-27,30.392,-27,30.392C-27,30.392,-27,27.392,-27,27.392C-27,27.392,-22.659,27.392,-22.659,27.392C-22.659,27.392,-22.628,0.375,-22.628,0.375C-22.628,0.375,-22.659,-29.552,-22.659,-29.552C-22.659,-29.552,-19.779,-29.552,-19.779,-29.552C-19.779,-29.552,-19.779,-27.552,-19.779,-27.552C-19.779,-27.552,-19.659,-27.552,-19.659,-27.552C-19.659,-27.552,-19.659,-29.552,-19.659,-29.552C-19.659,-29.552,-16.779,-29.552,-16.779,-29.552C-16.779,-29.552,-16.779,-25.42,-16.779,-25.42C-10.414,-28.713,-3.503,-30.392,2.78,-30.392C3.284,-30.392,3.748,-30.354,4.231,-30.335C4.748,-30.357,5.27,-30.392,5.78,-30.392C16.339,-30.392,22.339,-26.193,22.339,-15.393C22.339,-15.393,22.37,0.25,22.37,0.25C22.37,0.25,22.339,27.392,22.339,27.392C22.339,27.392,27,27.392,27,27.392C27,27.392,27,30.392,27,30.392Z",
    fillRule: "evenodd",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "M27,30.392C27,30.392,12,30.392,12,30.392C12,30.392,12,27.392,12,27.392C12,27.392,16.339,27.392,16.339,27.392C16.339,27.392,16.37,0.375,16.37,0.375C16.37,0.375,16.028,-19.396,15.402,-21.076C13.19,-24.42,9.039,-25.752,2.7,-25.752C-3.598,-25.752,-10.286,-23.964,-16.659,-20.337C-16.659,-20.337,-16.628,0.375,-16.628,0.375C-16.628,0.375,-16.659,27.392,-16.659,27.392C-16.659,27.392,-12,27.392,-12,27.392C-12,27.392,-12,30.392,-12,30.392C-12,30.392,-27,30.392,-27,30.392C-27,30.392,-27,27.392,-27,27.392C-27,27.392,-22.659,27.392,-22.659,27.392C-22.659,27.392,-22.628,0.375,-22.628,0.375C-22.628,0.375,-22.659,-29.552,-22.659,-29.552C-22.659,-29.552,-19.779,-29.552,-19.779,-29.552C-19.779,-29.552,-19.779,-27.552,-19.779,-27.552C-19.779,-27.552,-19.659,-27.552,-19.659,-27.552C-19.659,-27.552,-19.659,-29.552,-19.659,-29.552C-19.659,-29.552,-16.779,-29.552,-16.779,-29.552C-16.779,-29.552,-16.779,-25.42,-16.779,-25.42C-10.414,-28.713,-3.503,-30.392,2.78,-30.392C3.284,-30.392,3.748,-30.354,4.231,-30.335C4.748,-30.357,5.27,-30.392,5.78,-30.392C16.339,-30.392,22.339,-26.193,22.339,-15.393C22.339,-15.393,22.37,0.25,22.37,0.25C22.37,0.25,22.339,27.392,22.339,27.392C22.339,27.392,27,27.392,27,27.392C27,27.392,27,30.392,27,30.392Z; M27,30.392C27,30.392,12,30.392,12,30.392C12,30.392,12,27.392,12,27.392C12,27.392,16.339,27.392,16.339,27.392C16.339,27.392,16.37,0.375,16.37,0.375C16.37,0.375,16.028,-19.396,15.402,-21.076C13.19,-24.42,9.039,-25.752,2.7,-25.752C-3.598,-25.752,-10.286,-23.964,-16.659,-20.337C-16.659,-20.337,-16.628,0.375,-16.628,0.375C-16.628,0.375,-16.659,27.392,-16.659,27.392C-16.659,27.392,-12,27.392,-12,27.392C-12,27.392,-12,30.392,-12,30.392C-12,30.392,-27,30.392,-27,30.392C-27,30.392,-27,27.392,-27,27.392C-27,27.392,-22.659,27.392,-22.659,27.392C-22.659,27.392,-22.628,0.375,-22.628,0.375C-22.628,0.375,-22.659,-29.552,-22.659,-29.552C-22.659,-29.552,-19.779,-29.552,-19.779,-29.552C-19.779,-29.552,-19.779,-27.552,-19.779,-27.552C-19.779,-27.552,-19.659,-27.552,-19.659,-27.552C-19.659,-27.552,-19.659,-29.552,-19.659,-29.552C-19.659,-29.552,-16.779,-29.552,-16.779,-29.552C-16.779,-29.552,-16.779,-25.42,-16.779,-25.42C-10.414,-28.713,-3.503,-30.392,2.78,-30.392C3.284,-30.392,3.748,-30.354,4.231,-30.335C4.748,-30.357,5.27,-30.392,5.78,-30.392C16.339,-30.392,22.339,-26.193,22.339,-15.393C22.339,-15.393,22.37,0.25,22.37,0.25C22.37,0.25,22.339,27.392,22.339,27.392C22.339,27.392,27,27.392,27,27.392C27,27.392,27,30.392,27,30.392Z; M27,30.392C27,30.392,12,30.392,12,30.392C12,30.392,12,27.392,12,27.392C12,27.392,16.339,27.392,16.339,27.392C16.339,27.392,23.745,11.625,23.745,0.375C23.745,-10.875,18.028,-18.007,17.402,-19.687C15.19,-23.031,9.039,-25.752,2.7,-25.752C-3.598,-25.752,-8.161,-23.825,-14.534,-20.198C-14.534,-20.198,-9.253,-10.875,-9.253,0.375C-9.253,11.625,-16.659,27.392,-16.659,27.392C-16.659,27.392,-12,27.392,-12,27.392C-12,27.392,-12,30.392,-12,30.392C-12,30.392,-27,30.392,-27,30.392C-27,30.392,-27,27.392,-27,27.392C-27,27.392,-22.659,27.392,-22.659,27.392C-22.659,27.392,-15.253,12.181,-15.253,0.375C-15.253,-11.431,-22.659,-29.552,-22.659,-29.552C-22.659,-29.552,-19.779,-29.552,-19.779,-29.552C-19.779,-29.552,-19.779,-27.552,-19.779,-27.552C-19.779,-27.552,-19.659,-27.552,-19.659,-27.552C-19.659,-27.552,-19.659,-29.552,-19.659,-29.552C-19.659,-29.552,-16.779,-29.552,-16.779,-29.552C-16.779,-29.552,-16.779,-25.42,-16.779,-25.42C-10.414,-28.713,-3.503,-30.392,2.78,-30.392C3.284,-30.392,3.748,-30.354,4.231,-30.335C4.748,-30.357,5.27,-30.392,5.78,-30.392C16.339,-30.392,21.178,-23.799,23.839,-18.448C26.5,-13.097,29.745,-7.93,29.745,0.25C29.745,8.431,22.339,27.392,22.339,27.392C22.339,27.392,27,27.392,27,27.392C27,27.392,27,30.392,27,30.392Z; M27,30.392C27,30.392,12,30.392,12,30.392C12,30.392,12,27.392,12,27.392C12,27.392,16.339,27.392,16.339,27.392C16.339,27.392,16.37,0.375,16.37,0.375C16.37,0.375,16.028,-19.396,15.402,-21.076C13.19,-24.42,9.039,-25.752,2.7,-25.752C-3.598,-25.752,-10.286,-23.964,-16.659,-20.337C-16.659,-20.337,-16.628,0.375,-16.628,0.375C-16.628,0.375,-16.659,27.392,-16.659,27.392C-16.659,27.392,-12,27.392,-12,27.392C-12,27.392,-12,30.392,-12,30.392C-12,30.392,-27,30.392,-27,30.392C-27,30.392,-27,27.392,-27,27.392C-27,27.392,-22.659,27.392,-22.659,27.392C-22.659,27.392,-22.628,0.375,-22.628,0.375C-22.628,0.375,-22.659,-29.552,-22.659,-29.552C-22.659,-29.552,-19.779,-29.552,-19.779,-29.552C-19.779,-29.552,-19.779,-27.552,-19.779,-27.552C-19.779,-27.552,-19.659,-27.552,-19.659,-27.552C-19.659,-27.552,-19.659,-29.552,-19.659,-29.552C-19.659,-29.552,-16.779,-29.552,-16.779,-29.552C-16.779,-29.552,-16.779,-25.42,-16.779,-25.42C-10.414,-28.713,-3.503,-30.392,2.78,-30.392C3.284,-30.392,3.748,-30.354,4.231,-30.335C4.748,-30.357,5.27,-30.392,5.78,-30.392C16.339,-30.392,22.339,-26.193,22.339,-15.393C22.339,-15.393,22.37,0.25,22.37,0.25C22.37,0.25,22.339,27.392,22.339,27.392C22.339,27.392,27,27.392,27,27.392C27,27.392,27,30.392,27,30.392Z; M27,30.392C27,30.392,12,30.392,12,30.392C12,30.392,12,27.392,12,27.392C12,27.392,16.339,27.392,16.339,27.392C16.339,27.392,16.37,0.375,16.37,0.375C16.37,0.375,16.028,-19.396,15.402,-21.076C13.19,-24.42,9.039,-25.752,2.7,-25.752C-3.598,-25.752,-10.286,-23.964,-16.659,-20.337C-16.659,-20.337,-16.628,0.375,-16.628,0.375C-16.628,0.375,-16.659,27.392,-16.659,27.392C-16.659,27.392,-12,27.392,-12,27.392C-12,27.392,-12,30.392,-12,30.392C-12,30.392,-27,30.392,-27,30.392C-27,30.392,-27,27.392,-27,27.392C-27,27.392,-22.659,27.392,-22.659,27.392C-22.659,27.392,-22.628,0.375,-22.628,0.375C-22.628,0.375,-22.659,-29.552,-22.659,-29.552C-22.659,-29.552,-19.779,-29.552,-19.779,-29.552C-19.779,-29.552,-19.779,-27.552,-19.779,-27.552C-19.779,-27.552,-19.659,-27.552,-19.659,-27.552C-19.659,-27.552,-19.659,-29.552,-19.659,-29.552C-19.659,-29.552,-16.779,-29.552,-16.779,-29.552C-16.779,-29.552,-16.779,-25.42,-16.779,-25.42C-10.414,-28.713,-3.503,-30.392,2.78,-30.392C3.284,-30.392,3.748,-30.354,4.231,-30.335C4.748,-30.357,5.27,-30.392,5.78,-30.392C16.339,-30.392,22.339,-26.193,22.339,-15.393C22.339,-15.393,22.37,0.25,22.37,0.25C22.37,0.25,22.339,27.392,22.339,27.392C22.339,27.392,27,27.392,27,27.392C27,27.392,27,30.392,27,30.392Z",
    keyTimes: "0; 0.613333; 0.653333; 0.693333; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.833 1; 0 0 1 1",
    fill: "freeze"
  })))))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-46,-93)",
    id: "i36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,734.637,259)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6b6b6b",
    fillRule: "evenodd",
    d: "M3.363,-8C3.363,-8,3.363,5.401,3.363,5.401C3.363,5.401,-3.362,-0.87,-3.362,-0.87C-3.362,-0.87,-3.362,-8,-3.362,-8C-3.362,-8,3.363,-8,3.363,-8ZM5.363,-10C5.363,-10,-5.362,-10,-5.362,-10C-5.362,-10,-5.362,0,-5.362,0C-5.362,0,5.363,10,5.363,10C5.363,10,5.363,-10,5.363,-10Z"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-46,-93)",
    id: "i37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,702,212)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 2,
    stroke: "#6b6b6b",
    d: "M-92,17C-92,17,58,-18,58,-18C58,-18,92,18,92,18"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-46,-93)",
    id: "i38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,610.5,278.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    fillRule: "evenodd",
    d: "M0,-1.5C0.827,-1.5,1.5,-0.827,1.5,0C1.5,0.827,0.827,1.5,0,1.5C-0.827,1.5,-1.5,0.827,-1.5,0C-1.5,-0.827,-0.827,-1.5,0,-1.5ZM0,-3.5C-1.933,-3.5,-3.5,-1.933,-3.5,0C-3.5,1.933,-1.933,3.5,0,3.5C1.933,3.5,3.5,1.933,3.5,0C3.5,-1.933,1.933,-3.5,0,-3.5Z"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-46,-93)",
    id: "i39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,680.5,341.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    fillRule: "evenodd",
    d: "M0,-0.5C0.275,-0.5,0.5,-0.275,0.5,0C0.5,0.275,0.275,0.5,0,0.5C-0.275,0.5,-0.5,0.275,-0.5,0C-0.5,-0.275,-0.275,-0.5,0,-0.5ZM0,-2.5C-1.381,-2.5,-2.5,-1.381,-2.5,0C-2.5,1.381,-1.381,2.5,0,2.5C1.381,2.5,2.5,1.381,2.5,0C2.5,-1.381,1.381,-2.5,0,-2.5Z"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,393.5,225)",
    id: "i40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i41",
    transform: "matrix(1,0,0,1,395.003,-82.082)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 15.836,
    width: 2.757,
    y: -7.918,
    x: -1.379,
    fillRule: "evenodd",
    fill: "#6b6b6b"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,408,186)",
    id: "i42"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#i0)",
    id: "i43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-163.856,-8.16C-163.856,-8.16,-163.856,-9.72,-163.856,-9.72C-163.856,-35.639,-151.376,-49.198,-129.897,-49.198C-120.658,-49.198,-115.258,-47.399,-110.818,-44.878C-110.818,-44.878,-110.818,-42.118,-110.818,-42.118C-115.618,-44.638,-121.257,-46.438,-129.897,-46.438C-149.457,-46.438,-160.736,-34.318,-160.736,-10.08C-160.736,-10.08,-160.736,-8.04,-160.736,-8.04C-160.736,16.079,-151.616,28.799,-131.217,28.799C-120.657,28.799,-115.018,26.039,-110.338,23.399C-110.338,23.399,-110.338,26.279,-110.338,26.279C-114.298,28.438,-120.178,31.559,-131.457,31.559C-153.296,31.559,-163.856,17.52,-163.856,-8.16Z"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,54.5,356)",
    id: "i44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i45"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M427.115,-7.379C414.171,-7.379,404.978,-15.605,404.978,-33.509C404.978,-33.509,404.978,-35.202,404.978,-35.202C404.978,-52.622,414.292,-61.695,427.115,-61.695C440.059,-61.695,449.374,-54.073,449.374,-35.565C449.374,-35.565,449.374,-33.993,449.374,-33.993C449.374,-16.21,440.059,-7.379,427.115,-7.379ZM427.115,-4.839C441.269,-4.839,452.277,-14.759,452.277,-34.235C452.277,-34.235,452.277,-35.323,452.277,-35.323C452.277,-54.799,441.873,-64.235,427.115,-64.235C413.082,-64.235,402.074,-54.436,402.074,-35.081C402.074,-35.081,402.074,-33.751,402.074,-33.751C402.074,-14.275,412.357,-4.839,427.115,-4.839Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i46"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M377.571,-4.839C391.362,-4.839,396.563,-11.734,396.563,-20.202C396.563,-29.88,391.604,-33.146,381.926,-36.049C381.926,-36.049,374.91,-38.106,374.91,-38.106C366.684,-40.646,363.78,-43.55,363.78,-50.566C363.78,-57.219,368.619,-61.574,378.539,-61.574C384.104,-61.574,389.668,-60.123,393.66,-58.187C393.66,-58.187,393.66,-60.727,393.66,-60.727C390.515,-62.542,385.555,-64.235,378.297,-64.235C366.805,-64.235,360.877,-58.671,360.877,-50.445C360.877,-41.735,364.99,-37.984,373.821,-35.565C373.821,-35.565,380.837,-33.388,380.837,-33.388C389.91,-30.848,393.539,-28.065,393.539,-20.081C393.539,-13.065,389.547,-7.5,377.329,-7.5C369.224,-7.5,364.264,-9.436,359.788,-11.613C359.788,-11.613,359.788,-8.952,359.788,-8.952C363.659,-6.895,369.587,-4.839,377.571,-4.839Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i47"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M305.78,-30.122C295.618,-30.122,288.481,-35.444,288.481,-45.243C288.481,-45.243,288.481,-46.574,288.481,-46.574C288.481,-56.131,295.497,-61.574,305.78,-61.574C315.941,-61.574,322.837,-56.736,322.837,-46.574C322.837,-46.574,322.837,-45.243,322.837,-45.243C322.837,-35.444,316.062,-30.122,305.78,-30.122ZM305.296,10.162C289.449,10.162,284.247,4.597,284.247,-2.54C284.247,-9.798,289.691,-11.372,296.828,-13.67C296.828,-13.67,314.369,-13.67,314.369,-13.67C323.079,-13.67,329.006,-13.67,329.006,-4.597C329.006,3.508,322.595,10.162,305.296,10.162ZM305.417,12.823C324.53,12.823,332.03,4.597,332.03,-4.96C332.03,-15.726,324.652,-16.573,314.732,-16.573C314.732,-16.573,297.433,-16.573,297.433,-16.573C292.836,-16.573,290.175,-19.113,290.175,-22.984C290.175,-26.25,292.231,-27.945,294.529,-30.001C297.795,-28.307,301.546,-27.702,305.78,-27.702C317.393,-27.702,325.861,-33.872,325.861,-45.364C325.861,-45.364,325.861,-46.574,325.861,-46.574C325.861,-53.227,322.958,-58.066,317.998,-60.727C317.998,-60.727,331.667,-60.727,331.667,-60.727C331.667,-60.727,331.667,-63.268,331.667,-63.268C331.667,-63.268,312.917,-63.268,312.917,-63.268C310.74,-63.752,308.441,-63.993,305.901,-63.993C294.046,-63.993,285.457,-57.34,285.457,-46.332C285.457,-46.332,285.457,-45.364,285.457,-45.364C285.457,-39.074,288.118,-33.992,292.715,-31.21C289.57,-28.307,287.15,-25.767,287.15,-22.259C287.15,-18.025,290.175,-15.242,293.32,-14.637C293.32,-14.637,293.32,-14.395,293.32,-14.395C286.667,-11.855,281.102,-9.919,281.102,-2.298C281.102,6.049,287.634,12.823,305.417,12.823Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i48"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M231.776,-5.686C231.776,-5.686,234.8,-5.686,234.8,-5.686C234.8,-5.686,234.8,-54.921,234.8,-54.921C241.816,-59.397,249.317,-61.574,256.333,-61.574C266.494,-61.574,271.091,-58.187,271.091,-48.63C271.091,-48.63,271.091,-5.686,271.091,-5.686C271.091,-5.686,274.115,-5.686,274.115,-5.686C274.115,-5.686,274.115,-49.114,274.115,-49.114C274.115,-60.001,268.066,-64.235,257.421,-64.235C250.163,-64.235,242.058,-62.058,234.921,-57.703C234.921,-57.703,234.679,-57.703,234.679,-57.703C234.679,-57.703,234.679,-63.389,234.679,-63.389C234.679,-63.389,231.776,-63.389,231.776,-63.389C231.776,-63.389,231.776,-5.686,231.776,-5.686Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i49"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M215.557,-76.816C215.557,-76.816,218.702,-76.816,218.702,-76.816C218.702,-76.816,218.702,-81.292,218.702,-81.292C218.702,-81.292,215.557,-81.292,215.557,-81.292C215.557,-81.292,215.557,-76.816,215.557,-76.816ZM215.678,-5.928C215.678,-5.928,218.702,-5.928,218.702,-5.928C218.702,-5.928,218.702,-63.509,218.702,-63.509C218.702,-63.509,215.678,-63.509,215.678,-63.509C215.678,-63.509,215.678,-5.928,215.678,-5.928Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i50"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M127.997,-5.686C127.997,-5.686,131.021,-5.686,131.021,-5.686C131.021,-5.686,131.021,-54.921,131.021,-54.921C138.037,-59.518,144.449,-61.574,150.981,-61.574C159.449,-61.574,163.925,-58.187,163.925,-48.63C163.925,-48.63,163.925,-5.686,163.925,-5.686C163.925,-5.686,167.07,-5.686,167.07,-5.686C167.07,-5.686,167.07,-49.114,167.07,-49.114C167.07,-51.533,166.707,-53.348,166.223,-55.042C173.965,-59.76,180.619,-61.574,186.426,-61.574C195.015,-61.574,200.216,-58.187,200.216,-48.63C200.216,-48.63,200.216,-5.686,200.216,-5.686C200.216,-5.686,203.119,-5.686,203.119,-5.686C203.119,-5.686,203.119,-49.114,203.119,-49.114C203.119,-60.001,196.708,-64.235,187.272,-64.235C180.982,-64.235,173.966,-62.542,165.74,-57.34C165.74,-57.34,165.498,-57.34,165.498,-57.34C163.079,-61.937,158.36,-64.235,151.586,-64.235C145.175,-64.235,138.279,-62.058,131.142,-57.703C131.142,-57.703,130.9,-57.703,130.9,-57.703C130.9,-57.703,130.9,-63.389,130.9,-63.389C130.9,-63.389,127.997,-63.389,127.997,-63.389C127.997,-63.389,127.997,-5.686,127.997,-5.686Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i45"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M93.07,-7.379C80.126,-7.379,70.932,-15.605,70.932,-33.509C70.932,-33.509,70.932,-35.202,70.932,-35.202C70.932,-52.622,80.247,-61.695,93.07,-61.695C106.014,-61.695,115.328,-54.073,115.328,-35.565C115.328,-35.565,115.328,-33.993,115.328,-33.993C115.328,-16.21,106.014,-7.379,93.07,-7.379ZM93.07,-4.839C107.224,-4.839,118.232,-14.759,118.232,-34.235C118.232,-34.235,118.232,-35.323,118.232,-35.323C118.232,-54.799,107.828,-64.235,93.07,-64.235C79.037,-64.235,68.029,-54.436,68.029,-35.081C68.029,-35.081,68.029,-33.751,68.029,-33.751C68.029,-14.275,78.312,-4.839,93.07,-4.839Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i51"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M39.315,-4.96C50.686,-4.96,56.614,-8.105,60.606,-10.282C60.606,-10.282,60.606,-13.186,60.606,-13.186C55.888,-10.525,50.202,-7.742,39.557,-7.742C18.992,-7.742,9.799,-20.565,9.799,-44.88C9.799,-44.88,9.799,-46.937,9.799,-46.937C9.799,-71.373,21.17,-83.591,40.888,-83.591C49.598,-83.591,55.283,-81.776,60.122,-79.236C60.122,-79.236,60.122,-82.018,60.122,-82.018C55.646,-84.558,50.203,-86.373,40.888,-86.373C19.234,-86.373,6.653,-72.704,6.653,-46.574C6.653,-46.574,6.653,-45.001,6.653,-45.001C6.653,-19.113,17.298,-4.96,39.315,-4.96Z"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,57.5,358)",
    id: "i52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i45"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M427.115,-7.379C414.171,-7.379,404.978,-15.605,404.978,-33.509C404.978,-33.509,404.978,-35.202,404.978,-35.202C404.978,-52.622,414.292,-61.695,427.115,-61.695C440.059,-61.695,449.374,-54.073,449.374,-35.565C449.374,-35.565,449.374,-33.993,449.374,-33.993C449.374,-16.21,440.059,-7.379,427.115,-7.379ZM427.115,-4.839C441.269,-4.839,452.277,-14.759,452.277,-34.235C452.277,-34.235,452.277,-35.323,452.277,-35.323C452.277,-54.799,441.873,-64.235,427.115,-64.235C413.082,-64.235,402.074,-54.436,402.074,-35.081C402.074,-35.081,402.074,-33.751,402.074,-33.751C402.074,-14.275,412.357,-4.839,427.115,-4.839Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i46"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M377.571,-4.839C391.362,-4.839,396.563,-11.734,396.563,-20.202C396.563,-29.88,391.604,-33.146,381.926,-36.049C381.926,-36.049,374.91,-38.106,374.91,-38.106C366.684,-40.646,363.78,-43.55,363.78,-50.566C363.78,-57.219,368.619,-61.574,378.539,-61.574C384.104,-61.574,389.668,-60.123,393.66,-58.187C393.66,-58.187,393.66,-60.727,393.66,-60.727C390.515,-62.542,385.555,-64.235,378.297,-64.235C366.805,-64.235,360.877,-58.671,360.877,-50.445C360.877,-41.735,364.99,-37.984,373.821,-35.565C373.821,-35.565,380.837,-33.388,380.837,-33.388C389.91,-30.848,393.539,-28.065,393.539,-20.081C393.539,-13.065,389.547,-7.5,377.329,-7.5C369.224,-7.5,364.264,-9.436,359.788,-11.613C359.788,-11.613,359.788,-8.952,359.788,-8.952C363.659,-6.895,369.587,-4.839,377.571,-4.839Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i47"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M305.78,-30.122C295.618,-30.122,288.481,-35.444,288.481,-45.243C288.481,-45.243,288.481,-46.574,288.481,-46.574C288.481,-56.131,295.497,-61.574,305.78,-61.574C315.941,-61.574,322.837,-56.736,322.837,-46.574C322.837,-46.574,322.837,-45.243,322.837,-45.243C322.837,-35.444,316.062,-30.122,305.78,-30.122ZM305.296,10.162C289.449,10.162,284.247,4.597,284.247,-2.54C284.247,-9.798,289.691,-11.372,296.828,-13.67C296.828,-13.67,314.369,-13.67,314.369,-13.67C323.079,-13.67,329.006,-13.67,329.006,-4.597C329.006,3.508,322.595,10.162,305.296,10.162ZM305.417,12.823C324.53,12.823,332.03,4.597,332.03,-4.96C332.03,-15.726,324.652,-16.573,314.732,-16.573C314.732,-16.573,297.433,-16.573,297.433,-16.573C292.836,-16.573,290.175,-19.113,290.175,-22.984C290.175,-26.25,292.231,-27.945,294.529,-30.001C297.795,-28.307,301.546,-27.702,305.78,-27.702C317.393,-27.702,325.861,-33.872,325.861,-45.364C325.861,-45.364,325.861,-46.574,325.861,-46.574C325.861,-53.227,322.958,-58.066,317.998,-60.727C317.998,-60.727,331.667,-60.727,331.667,-60.727C331.667,-60.727,331.667,-63.268,331.667,-63.268C331.667,-63.268,312.917,-63.268,312.917,-63.268C310.74,-63.752,308.441,-63.993,305.901,-63.993C294.046,-63.993,285.457,-57.34,285.457,-46.332C285.457,-46.332,285.457,-45.364,285.457,-45.364C285.457,-39.074,288.118,-33.992,292.715,-31.21C289.57,-28.307,287.15,-25.767,287.15,-22.259C287.15,-18.025,290.175,-15.242,293.32,-14.637C293.32,-14.637,293.32,-14.395,293.32,-14.395C286.667,-11.855,281.102,-9.919,281.102,-2.298C281.102,6.049,287.634,12.823,305.417,12.823Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i48"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M231.776,-5.686C231.776,-5.686,234.8,-5.686,234.8,-5.686C234.8,-5.686,234.8,-54.921,234.8,-54.921C241.816,-59.397,249.317,-61.574,256.333,-61.574C266.494,-61.574,271.091,-58.187,271.091,-48.63C271.091,-48.63,271.091,-5.686,271.091,-5.686C271.091,-5.686,274.115,-5.686,274.115,-5.686C274.115,-5.686,274.115,-49.114,274.115,-49.114C274.115,-60.001,268.066,-64.235,257.421,-64.235C250.163,-64.235,242.058,-62.058,234.921,-57.703C234.921,-57.703,234.679,-57.703,234.679,-57.703C234.679,-57.703,234.679,-63.389,234.679,-63.389C234.679,-63.389,231.776,-63.389,231.776,-63.389C231.776,-63.389,231.776,-5.686,231.776,-5.686Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i49"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M215.557,-76.816C215.557,-76.816,218.702,-76.816,218.702,-76.816C218.702,-76.816,218.702,-81.292,218.702,-81.292C218.702,-81.292,215.557,-81.292,215.557,-81.292C215.557,-81.292,215.557,-76.816,215.557,-76.816ZM215.678,-5.928C215.678,-5.928,218.702,-5.928,218.702,-5.928C218.702,-5.928,218.702,-63.509,218.702,-63.509C218.702,-63.509,215.678,-63.509,215.678,-63.509C215.678,-63.509,215.678,-5.928,215.678,-5.928Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i50"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M127.997,-5.686C127.997,-5.686,131.021,-5.686,131.021,-5.686C131.021,-5.686,131.021,-54.921,131.021,-54.921C138.037,-59.518,144.449,-61.574,150.981,-61.574C159.449,-61.574,163.925,-58.187,163.925,-48.63C163.925,-48.63,163.925,-5.686,163.925,-5.686C163.925,-5.686,167.07,-5.686,167.07,-5.686C167.07,-5.686,167.07,-49.114,167.07,-49.114C167.07,-51.533,166.707,-53.348,166.223,-55.042C173.965,-59.76,180.619,-61.574,186.426,-61.574C195.015,-61.574,200.216,-58.187,200.216,-48.63C200.216,-48.63,200.216,-5.686,200.216,-5.686C200.216,-5.686,203.119,-5.686,203.119,-5.686C203.119,-5.686,203.119,-49.114,203.119,-49.114C203.119,-60.001,196.708,-64.235,187.272,-64.235C180.982,-64.235,173.966,-62.542,165.74,-57.34C165.74,-57.34,165.498,-57.34,165.498,-57.34C163.079,-61.937,158.36,-64.235,151.586,-64.235C145.175,-64.235,138.279,-62.058,131.142,-57.703C131.142,-57.703,130.9,-57.703,130.9,-57.703C130.9,-57.703,130.9,-63.389,130.9,-63.389C130.9,-63.389,127.997,-63.389,127.997,-63.389C127.997,-63.389,127.997,-5.686,127.997,-5.686Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i45"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M93.07,-7.379C80.126,-7.379,70.932,-15.605,70.932,-33.509C70.932,-33.509,70.932,-35.202,70.932,-35.202C70.932,-52.622,80.247,-61.695,93.07,-61.695C106.014,-61.695,115.328,-54.073,115.328,-35.565C115.328,-35.565,115.328,-33.993,115.328,-33.993C115.328,-16.21,106.014,-7.379,93.07,-7.379ZM93.07,-4.839C107.224,-4.839,118.232,-14.759,118.232,-34.235C118.232,-34.235,118.232,-35.323,118.232,-35.323C118.232,-54.799,107.828,-64.235,93.07,-64.235C79.037,-64.235,68.029,-54.436,68.029,-35.081C68.029,-35.081,68.029,-33.751,68.029,-33.751C68.029,-14.275,78.312,-4.839,93.07,-4.839Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i51"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M39.315,-4.96C50.686,-4.96,56.614,-8.105,60.606,-10.282C60.606,-10.282,60.606,-13.186,60.606,-13.186C55.888,-10.525,50.202,-7.742,39.557,-7.742C18.992,-7.742,9.799,-20.565,9.799,-44.88C9.799,-44.88,9.799,-46.937,9.799,-46.937C9.799,-71.373,21.17,-83.591,40.888,-83.591C49.598,-83.591,55.283,-81.776,60.122,-79.236C60.122,-79.236,60.122,-82.018,60.122,-82.018C55.646,-84.558,50.203,-86.373,40.888,-86.373C19.234,-86.373,6.653,-72.704,6.653,-46.574C6.653,-46.574,6.653,-45.001,6.653,-45.001C6.653,-19.113,17.298,-4.96,39.315,-4.96Z"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,60.5,356)",
    id: "i53"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i45"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M427.115,-7.379C414.171,-7.379,404.978,-15.605,404.978,-33.509C404.978,-33.509,404.978,-35.202,404.978,-35.202C404.978,-52.622,414.292,-61.695,427.115,-61.695C440.059,-61.695,449.374,-54.073,449.374,-35.565C449.374,-35.565,449.374,-33.993,449.374,-33.993C449.374,-16.21,440.059,-7.379,427.115,-7.379ZM427.115,-4.839C441.269,-4.839,452.277,-14.759,452.277,-34.235C452.277,-34.235,452.277,-35.323,452.277,-35.323C452.277,-54.799,441.873,-64.235,427.115,-64.235C413.082,-64.235,402.074,-54.436,402.074,-35.081C402.074,-35.081,402.074,-33.751,402.074,-33.751C402.074,-14.275,412.357,-4.839,427.115,-4.839Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i46"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M377.571,-4.839C391.362,-4.839,396.563,-11.734,396.563,-20.202C396.563,-29.88,391.604,-33.146,381.926,-36.049C381.926,-36.049,374.91,-38.106,374.91,-38.106C366.684,-40.646,363.78,-43.55,363.78,-50.566C363.78,-57.219,368.619,-61.574,378.539,-61.574C384.104,-61.574,389.668,-60.123,393.66,-58.187C393.66,-58.187,393.66,-60.727,393.66,-60.727C390.515,-62.542,385.555,-64.235,378.297,-64.235C366.805,-64.235,360.877,-58.671,360.877,-50.445C360.877,-41.735,364.99,-37.984,373.821,-35.565C373.821,-35.565,380.837,-33.388,380.837,-33.388C389.91,-30.848,393.539,-28.065,393.539,-20.081C393.539,-13.065,389.547,-7.5,377.329,-7.5C369.224,-7.5,364.264,-9.436,359.788,-11.613C359.788,-11.613,359.788,-8.952,359.788,-8.952C363.659,-6.895,369.587,-4.839,377.571,-4.839Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i47"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M305.78,-30.122C295.618,-30.122,288.481,-35.444,288.481,-45.243C288.481,-45.243,288.481,-46.574,288.481,-46.574C288.481,-56.131,295.497,-61.574,305.78,-61.574C315.941,-61.574,322.837,-56.736,322.837,-46.574C322.837,-46.574,322.837,-45.243,322.837,-45.243C322.837,-35.444,316.062,-30.122,305.78,-30.122ZM305.296,10.162C289.449,10.162,284.247,4.597,284.247,-2.54C284.247,-9.798,289.691,-11.372,296.828,-13.67C296.828,-13.67,314.369,-13.67,314.369,-13.67C323.079,-13.67,329.006,-13.67,329.006,-4.597C329.006,3.508,322.595,10.162,305.296,10.162ZM305.417,12.823C324.53,12.823,332.03,4.597,332.03,-4.96C332.03,-15.726,324.652,-16.573,314.732,-16.573C314.732,-16.573,297.433,-16.573,297.433,-16.573C292.836,-16.573,290.175,-19.113,290.175,-22.984C290.175,-26.25,292.231,-27.945,294.529,-30.001C297.795,-28.307,301.546,-27.702,305.78,-27.702C317.393,-27.702,325.861,-33.872,325.861,-45.364C325.861,-45.364,325.861,-46.574,325.861,-46.574C325.861,-53.227,322.958,-58.066,317.998,-60.727C317.998,-60.727,331.667,-60.727,331.667,-60.727C331.667,-60.727,331.667,-63.268,331.667,-63.268C331.667,-63.268,312.917,-63.268,312.917,-63.268C310.74,-63.752,308.441,-63.993,305.901,-63.993C294.046,-63.993,285.457,-57.34,285.457,-46.332C285.457,-46.332,285.457,-45.364,285.457,-45.364C285.457,-39.074,288.118,-33.992,292.715,-31.21C289.57,-28.307,287.15,-25.767,287.15,-22.259C287.15,-18.025,290.175,-15.242,293.32,-14.637C293.32,-14.637,293.32,-14.395,293.32,-14.395C286.667,-11.855,281.102,-9.919,281.102,-2.298C281.102,6.049,287.634,12.823,305.417,12.823Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i48"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M231.776,-5.686C231.776,-5.686,234.8,-5.686,234.8,-5.686C234.8,-5.686,234.8,-54.921,234.8,-54.921C241.816,-59.397,249.317,-61.574,256.333,-61.574C266.494,-61.574,271.091,-58.187,271.091,-48.63C271.091,-48.63,271.091,-5.686,271.091,-5.686C271.091,-5.686,274.115,-5.686,274.115,-5.686C274.115,-5.686,274.115,-49.114,274.115,-49.114C274.115,-60.001,268.066,-64.235,257.421,-64.235C250.163,-64.235,242.058,-62.058,234.921,-57.703C234.921,-57.703,234.679,-57.703,234.679,-57.703C234.679,-57.703,234.679,-63.389,234.679,-63.389C234.679,-63.389,231.776,-63.389,231.776,-63.389C231.776,-63.389,231.776,-5.686,231.776,-5.686Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i49"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M215.557,-76.816C215.557,-76.816,218.702,-76.816,218.702,-76.816C218.702,-76.816,218.702,-81.292,218.702,-81.292C218.702,-81.292,215.557,-81.292,215.557,-81.292C215.557,-81.292,215.557,-76.816,215.557,-76.816ZM215.678,-5.928C215.678,-5.928,218.702,-5.928,218.702,-5.928C218.702,-5.928,218.702,-63.509,218.702,-63.509C218.702,-63.509,215.678,-63.509,215.678,-63.509C215.678,-63.509,215.678,-5.928,215.678,-5.928Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i50"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M127.997,-5.686C127.997,-5.686,131.021,-5.686,131.021,-5.686C131.021,-5.686,131.021,-54.921,131.021,-54.921C138.037,-59.518,144.449,-61.574,150.981,-61.574C159.449,-61.574,163.925,-58.187,163.925,-48.63C163.925,-48.63,163.925,-5.686,163.925,-5.686C163.925,-5.686,167.07,-5.686,167.07,-5.686C167.07,-5.686,167.07,-49.114,167.07,-49.114C167.07,-51.533,166.707,-53.348,166.223,-55.042C173.965,-59.76,180.619,-61.574,186.426,-61.574C195.015,-61.574,200.216,-58.187,200.216,-48.63C200.216,-48.63,200.216,-5.686,200.216,-5.686C200.216,-5.686,203.119,-5.686,203.119,-5.686C203.119,-5.686,203.119,-49.114,203.119,-49.114C203.119,-60.001,196.708,-64.235,187.272,-64.235C180.982,-64.235,173.966,-62.542,165.74,-57.34C165.74,-57.34,165.498,-57.34,165.498,-57.34C163.079,-61.937,158.36,-64.235,151.586,-64.235C145.175,-64.235,138.279,-62.058,131.142,-57.703C131.142,-57.703,130.9,-57.703,130.9,-57.703C130.9,-57.703,130.9,-63.389,130.9,-63.389C130.9,-63.389,127.997,-63.389,127.997,-63.389C127.997,-63.389,127.997,-5.686,127.997,-5.686Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i45"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M93.07,-7.379C80.126,-7.379,70.932,-15.605,70.932,-33.509C70.932,-33.509,70.932,-35.202,70.932,-35.202C70.932,-52.622,80.247,-61.695,93.07,-61.695C106.014,-61.695,115.328,-54.073,115.328,-35.565C115.328,-35.565,115.328,-33.993,115.328,-33.993C115.328,-16.21,106.014,-7.379,93.07,-7.379ZM93.07,-4.839C107.224,-4.839,118.232,-14.759,118.232,-34.235C118.232,-34.235,118.232,-35.323,118.232,-35.323C118.232,-54.799,107.828,-64.235,93.07,-64.235C79.037,-64.235,68.029,-54.436,68.029,-35.081C68.029,-35.081,68.029,-33.751,68.029,-33.751C68.029,-14.275,78.312,-4.839,93.07,-4.839Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i51"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M39.315,-4.96C50.686,-4.96,56.614,-8.105,60.606,-10.282C60.606,-10.282,60.606,-13.186,60.606,-13.186C55.888,-10.525,50.202,-7.742,39.557,-7.742C18.992,-7.742,9.799,-20.565,9.799,-44.88C9.799,-44.88,9.799,-46.937,9.799,-46.937C9.799,-71.373,21.17,-83.591,40.888,-83.591C49.598,-83.591,55.283,-81.776,60.122,-79.236C60.122,-79.236,60.122,-82.018,60.122,-82.018C55.646,-84.558,50.203,-86.373,40.888,-86.373C19.234,-86.373,6.653,-72.704,6.653,-46.574C6.653,-46.574,6.653,-45.001,6.653,-45.001C6.653,-19.113,17.298,-4.96,39.315,-4.96Z"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "i54"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    values: "1; 1; 0; 0",
    keyTimes: "0; 0.613333; 0.626667; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(538,197)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "538 197; 538 264; 538 264; 538 294; 538 294",
    keyTimes: "0; 0.266667; 0.546666; 0.626667; 1",
    keySplines: "1 0.024 0.833 0.833; 0 0 1 1; 0.868 0 0.833 0.833; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; -14; 13.704; -5.296; 11.704; -4.296; 0; 0",
    keyTimes: "0; 0.24; 0.333333; 0.4; 0.466667; 0.52; 0.56; 0.586667; 1",
    keySplines: "0 0 1 1; 0.333 0 0.072 1; 0.333 0 0.238 0.989; 0.333 0 0.213 1; 0.333 0 0.162 1; 0.333 0 0.162 1; 0.333 0 0.225 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-24.463,62.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i45"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M30.968,-7.379C18.024,-7.379,8.831,-15.605,8.831,-33.509C8.831,-33.509,8.831,-35.202,8.831,-35.202C8.831,-52.622,18.145,-61.695,30.968,-61.695C43.912,-61.695,53.227,-54.073,53.227,-35.565C53.227,-35.565,53.227,-33.993,53.227,-33.993C53.227,-16.21,43.912,-7.379,30.968,-7.379ZM30.968,-4.839C45.122,-4.839,56.13,-14.759,56.13,-34.235C56.13,-34.235,56.13,-35.323,56.13,-35.323C56.13,-54.799,45.726,-64.235,30.968,-64.235C16.935,-64.235,5.928,-54.436,5.928,-35.081C5.928,-35.081,5.928,-33.751,5.928,-33.751C5.928,-14.275,16.21,-4.839,30.968,-4.839Z"
  }))))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "i54"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(538,197)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "538 197; 538 264; 538 264; 538 294; 538 294",
    keyTimes: "0; 0.266667; 0.546666; 0.626667; 1",
    keySplines: "1 0.024 0.833 0.833; 0 0 1 1; 0.868 0 0.833 0.833; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; -14; 13.704; -5.296; 11.704; -4.296; 0; 0",
    keyTimes: "0; 0.24; 0.333333; 0.4; 0.466667; 0.52; 0.56; 0.586667; 1",
    keySplines: "0 0 1 1; 0.333 0 0.072 1; 0.333 0 0.238 0.989; 0.333 0 0.213 1; 0.333 0 0.162 1; 0.333 0 0.162 1; 0.333 0 0.225 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-24.463,62.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i55"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    values: "1; 1; 0; 0",
    keyTimes: "0; 0.613333; 0.626667; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.38,-63.281) scale(1,1) translate(-26.294,61.781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i45"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M30.968,-7.379C18.024,-7.379,8.831,-15.605,8.831,-33.509C8.831,-33.509,8.831,-35.202,8.831,-35.202C8.831,-52.622,18.145,-61.695,30.968,-61.695C43.912,-61.695,53.227,-54.073,53.227,-35.565C53.227,-35.565,53.227,-33.993,53.227,-33.993C53.227,-16.21,43.912,-7.379,30.968,-7.379ZM30.968,-4.839C45.122,-4.839,56.13,-14.759,56.13,-34.235C56.13,-34.235,56.13,-35.323,56.13,-35.323C56.13,-54.799,45.726,-64.235,30.968,-64.235C16.935,-64.235,5.928,-54.436,5.928,-35.081C5.928,-35.081,5.928,-33.751,5.928,-33.751C5.928,-14.275,16.21,-4.839,30.968,-4.839Z"
  }))))))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "i54"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(538,197)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "538 197; 538 264; 538 264; 538 294; 538 294",
    keyTimes: "0; 0.266667; 0.546666; 0.626667; 1",
    keySplines: "1 0.024 0.833 0.833; 0 0 1 1; 0.868 0 0.833 0.833; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; -14; 13.704; -5.296; 11.704; -4.296; 0; 0",
    keyTimes: "0; 0.24; 0.333333; 0.4; 0.466667; 0.52; 0.56; 0.586667; 1",
    keySplines: "0 0 1 1; 0.333 0 0.072 1; 0.333 0 0.238 0.989; 0.333 0 0.213 1; 0.333 0 0.162 1; 0.333 0 0.162 1; 0.333 0 0.225 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-24.463,62.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i56"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    values: "1; 1; 0; 0",
    keyTimes: "0; 0.613333; 0.626667; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.08,-61.869) scale(1,1) translate(-22.808,61.369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i45"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M30.968,-7.379C18.024,-7.379,8.831,-15.605,8.831,-33.509C8.831,-33.509,8.831,-35.202,8.831,-35.202C8.831,-52.622,18.145,-61.695,30.968,-61.695C43.912,-61.695,53.227,-54.073,53.227,-35.565C53.227,-35.565,53.227,-33.993,53.227,-33.993C53.227,-16.21,43.912,-7.379,30.968,-7.379ZM30.968,-4.839C45.122,-4.839,56.13,-14.759,56.13,-34.235C56.13,-34.235,56.13,-35.323,56.13,-35.323C56.13,-54.799,45.726,-64.235,30.968,-64.235C16.935,-64.235,5.928,-54.436,5.928,-35.081C5.928,-35.081,5.928,-33.751,5.928,-33.751C5.928,-14.275,16.21,-4.839,30.968,-4.839Z"
  }))))))))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "i57"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 1; 1",
    keyTimes: "0; 0.613333; 0.626667; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(537.5,322)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "537.5 322; 537.5 322; 537.5 352; 537.5 352",
    keyTimes: "0; 0.546667; 0.626667; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1.16 0.7; 0.95 1.05; 1.06 0.9; 0.98 1; 0.98 1",
    keyTimes: "0; 0.546667; 0.626667; 0.693333; 0.746667; 0.8; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.006,4.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i45"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M30.968,-7.379C18.024,-7.379,8.831,-15.605,8.831,-33.509C8.831,-33.509,8.831,-35.202,8.831,-35.202C8.831,-52.622,18.145,-61.695,30.968,-61.695C43.912,-61.695,53.227,-54.073,53.227,-35.565C53.227,-35.565,53.227,-33.993,53.227,-33.993C53.227,-16.21,43.912,-7.379,30.968,-7.379ZM30.968,-4.839C45.122,-4.839,56.13,-14.759,56.13,-34.235C56.13,-34.235,56.13,-35.323,56.13,-35.323C56.13,-54.799,45.726,-64.235,30.968,-64.235C16.935,-64.235,5.928,-54.436,5.928,-35.081C5.928,-35.081,5.928,-33.751,5.928,-33.751C5.928,-14.275,16.21,-4.839,30.968,-4.839Z"
  }))))))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "i57"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(537.5,322)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "537.5 322; 537.5 322; 537.5 352; 537.5 352",
    keyTimes: "0; 0.546667; 0.626667; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1.16 0.7; 0.95 1.05; 1.06 0.9; 0.98 1; 0.98 1",
    keyTimes: "0; 0.546667; 0.626667; 0.693333; 0.746667; 0.8; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.006,4.974)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "i58"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 1; 1",
    keyTimes: "0; 0.613333; 0.626667; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.928,-60.228) scale(0.98,1.02) translate(-26.294,61.781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i45"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M30.968,-7.379C18.024,-7.379,8.831,-15.605,8.831,-33.509C8.831,-33.509,8.831,-35.202,8.831,-35.202C8.831,-52.622,18.145,-61.695,30.968,-61.695C43.912,-61.695,53.227,-54.073,53.227,-35.565C53.227,-35.565,53.227,-33.993,53.227,-33.993C53.227,-16.21,43.912,-7.379,30.968,-7.379ZM30.968,-4.839C45.122,-4.839,56.13,-14.759,56.13,-34.235C56.13,-34.235,56.13,-35.323,56.13,-35.323C56.13,-54.799,45.726,-64.235,30.968,-64.235C16.935,-64.235,5.928,-54.436,5.928,-35.081C5.928,-35.081,5.928,-33.751,5.928,-33.751C5.928,-14.275,16.21,-4.839,30.968,-4.839Z"
  }))))))))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "i57"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(537.5,322)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "537.5 322; 537.5 322; 537.5 352; 537.5 352",
    keyTimes: "0; 0.546667; 0.626667; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1.16 0.7; 0.95 1.05; 1.06 0.9; 0.98 1; 0.98 1",
    keyTimes: "0; 0.546667; 0.626667; 0.693333; 0.746667; 0.8; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.006,4.974)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "i59"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 1; 1",
    keyTimes: "0; 0.613333; 0.626667; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.814,-62.359) scale(0.98,1.02) translate(-22.808,61.369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i45"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M30.968,-7.379C18.024,-7.379,8.831,-15.605,8.831,-33.509C8.831,-33.509,8.831,-35.202,8.831,-35.202C8.831,-52.622,18.145,-61.695,30.968,-61.695C43.912,-61.695,53.227,-54.073,53.227,-35.565C53.227,-35.565,53.227,-33.993,53.227,-33.993C53.227,-16.21,43.912,-7.379,30.968,-7.379ZM30.968,-4.839C45.122,-4.839,56.13,-14.759,56.13,-34.235C56.13,-34.235,56.13,-35.323,56.13,-35.323C56.13,-54.799,45.726,-64.235,30.968,-64.235C16.935,-64.235,5.928,-54.436,5.928,-35.081C5.928,-35.081,5.928,-33.751,5.928,-33.751C5.928,-14.275,16.21,-4.839,30.968,-4.839Z"
  }))))))))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,408,186)",
    id: "i60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingsoon);
export default __webpack_public_path__ + "static/media/coming soon.3b68b2f0901747af8c94e64df66ebe6a.svg";
export { ForwardRef as ReactComponent };